import Axios, { AxiosResponse, InternalAxiosRequestConfig, AxiosError } from 'axios';

import { LOCAL_STORAGE_KEYS } from '@/constants';
import { API_URL } from '@/config/environments';
import { navigateToLogin } from '@/utils';

const instance = Axios.create({ baseURL: API_URL });

// 👉 Response
const errorRequestHandler = (error: AxiosError) => Promise.reject(error);
const successRequestHandler = (config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN);
  if (token) {
    if (!config.headers?.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
};

// 👉 Response
const errorResponseHandler = (error: AxiosError) => {
  navigateToLogin(error);
  return Promise.reject(error);
};
const successResponseHandler = (response: AxiosResponse) => response;

instance.interceptors.request.use(successRequestHandler, errorRequestHandler);
instance.interceptors.response.use(successResponseHandler, errorResponseHandler);

export default instance;
